<script>
export default {
  name: "AppAddresses",
};
</script>
<template>
  <section class="app__addresses">
    <router-view v-slot="{ Component }">
      <transition
        name="app__adressess-transition"
        enter-active-class="app__animated app__animated--fade-in"
        leave-active-class="app__animated app__animated--fade-out"
        mode="out-in"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </section>
</template>
